<template>
	<div
		class="g-block-qrcode-nav"
		:class="[
			`g-block-qrcode-nav--${variant}`,
			{
				'g-block-qrcode-nav--edit': editable,
				'is-active': editable && active,
				'g-block-qrcode-nav--h5': h5,
			},
		]"
		@click="onWrapClick"
	>
		<button
			type="button"
			class="g-block-qrcode-nav__btn"
			:style="buttonStyle"
			@click="onButtonClick"
		>{{ buttonText }}</button>
	</div>
</template>

<script>
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import { getQrcodeNavButtonStyle } from '../../../utils/qrcodeNav.js';

	const BLOCK_TYPE_MAP = {
		solid: 'qrcode-nav-solid',
		gradient: 'qrcode-nav-gradient',
		outline: 'qrcode-nav-outline',
	};

	export default {
		name: 'GQrcodeNavShell',
		props: {
			variant: {
				type: String,
				default: 'solid',
			},
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select'],
		computed: {
			buttonText() {
				return this.data.buttonText || '查看详情';
			},
			blockType() {
				return BLOCK_TYPE_MAP[this.variant] || BLOCK_TYPE_MAP.solid;
			},
			buttonStyle() {
				const style = getQrcodeNavButtonStyle(this.blockType, this.data);
				if (!this.h5) {
					return style;
				}
				const borderRadius = this.data.borderRadius ?? (this.variant === 'solid' ? 4 : 22);
				const width = this.data.buttonWidth > 0 ? `${this.data.buttonWidth / 50}rem` : '100%';
				return {
					...style,
					width,
					height: '0.88rem',
					lineHeight: '0.88rem',
					fontSize: '0.3rem',
					borderRadius: `${borderRadius / 50}rem`,
				};
			},
		},
		methods: {
			onWrapClick(e) {
				if (!this.editable) return;
				e?.stopPropagation?.();
				this.$emit('select');
			},
			onButtonClick(e) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.h5 && this.data.jumpLink?.type) {
					navigateJumpLink(this.data.jumpLink, {
						apiRequest: this.$apiRequest,
					});
				}
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-qrcode-nav {
		padding: 8px 24px;
		box-sizing: border-box;

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}

		&--h5 {
			padding: 0.16rem 0.3rem;
		}
	}

	.g-block-qrcode-nav__btn {
		display: block;
		max-width: 100%;
		margin: 0 auto;
		padding: 0 16px;
		border: none;
		font-weight: 500;
		text-align: center;
		cursor: pointer;
		box-sizing: border-box;
		font-family: inherit;
	}
</style>
